import 'angular';
import '../../../../../lib/assets/javascripts/devex/alerts';
import '../../../../../lib/assets/javascripts/devex/util';
import '../models/tracked_report.model';
import template from './track_report_button.template.html?raw';

const moduleDependencies = ['fundingSearchApp.models.trackedReport'];

angular
  .module('fundingSearchApp.directives.trackReportButton', moduleDependencies)
  .run(['$templateCache', ($templateCache) => {
    $templateCache.put(template, template);
  }])
  .directive('trackReportButton', [
    'TrackedReport',
    (TrackedReport) => {
      const link = ($scope) => {
        const toggleTrackingReportStatus = (action, message) => {
          const report = $scope.report;
          $scope.isLoading = true;

          TrackedReport[action](
            {
              report_id: report.id,
              report_type: devex.util.snakeCase(report.type),
            },
            () => {
              $scope.isLoading = false;
              report.tracked_by_me = !report.tracked_by_me;
              devex.alerts.showAlert(message, 'success');
              $scope.toggleTrackReport(report);
            }
          );
        };

        $scope.toggleTracking = () => {
          let action = 'save';
          let message = 'You are now tracking this report';

          if ($scope.report.tracked_by_me) {
            action = 'remove';
            message = 'You are no longer tracking this report';
          }

          toggleTrackingReportStatus(action, message);
        };
      };

      return {
        restrict: 'E',
        templateUrl: template,
        scope: {
          toggleTrackReport: '=',
          report: '=',
        },
        link,
      };
    },
  ]);
